import React, { useState } from "react";
import { useMoralisDapp } from "providers/MoralisDappProvider/MoralisDappProvider";
import { useMoralis, useMoralisQuery } from "react-moralis";
import NFTComponent from "./NFTComponent";

function NFTBuilderPasses() {
 
  const { marketAddressPass, contractABIPass, walletAddress } =
    useMoralisDapp();
  const contractABIJson = JSON.parse(contractABIPass);
  const { isAuthenticated, authenticate, Moralis } = useMoralis();
  const claimFunction = "noOfAirdroppedNFT";
  const claimNFTFunction = "claim";

  const queryMarketItems = useMoralisQuery("NftCreated");

  const fetchMarketItems = JSON.parse(
    JSON.stringify(queryMarketItems.data, [
      "objectId",
      "createdAt",
      "copies",
      "remainingCopies",
      "price",
      "metadata",
      "nftOwner",
      "nftId",
      "signature",
      "nonce",
      "name",
      "image",
      "description",
    ])
  ).filter((item) => item.nftId > 2);


  return (
    <div className="mt-0 pt-0 s-p">
      <div className="container">
        <h2 className="card-title text-center mt-0 mb-3">
          Community Builder Passes
        </h2>
        <p className="card-subtitle text-center">
          Soul Bound Tokens that symbolize association with or work contributors
          to the Web3 Texas Community
        </p>
        <div className="row my-5">
          {fetchMarketItems?.map((item, index) => (
            <NFTComponent nft={item} index={index + 1}  />
          ))}
        </div>
      </div>
      
    </div>
  );
}

export default NFTBuilderPasses;
